module.exports = __webpack_public_path__ + "media/images/icons/SVG/005-139ad27123548bd25aed56ce20cddc90.svg";